module.exports = __webpack_public_path__ + "img/img-play8-fish-s.18e440fd.png";